import React from 'react';

export const BreweryIdContext = React.createContext({});
export const BreweryContext = React.createContext({});
export const CustomerContext = React.createContext({});
export const CartContext = React.createContext({});